<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-12-03 09:03:06
 * @LastEditTime: 2026-06-25 13:54:12
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 核对明细单弹窗
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\checkDetail.vue
-->
<template>
    <div>
        <el-dialog :visible.sync="visible" :fullscreen="true" width="1280px" :close-on-click-modal="false" @open="open"
            @close="reset">
            <span slot="title" class="dialog-title">核对明细单</span>
            <div class="bill_top">
                <span><span class="text">工程名称：</span>{{ centerRow.engineeringName }}</span>
                <span style="margin-left:24px"><span class="text">结算时间段：</span>{{ centerRow.lastDueTime }}至{{
                    centerRow.currentDueTime
                }}</span>
            </div>
            <div class="dialoginfo">
                <div class="search">
                    <span style="display: inline-block; margin-bottom: 10px">
                        <span style="margin-right: 12px">送货时间</span>
                        <el-date-picker v-model="checkDetailParams.sendTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期" style="width: 120px;" @change="queryCheckDetail()">
                        </el-date-picker>
                    </span>
                    <span style="margin-left: 24px;">
                        <span style="margin-right: 12px;">浇筑部位</span>
                        <el-input v-model="checkDetailParams.pourPart" style="width: 120px;" placeholder="请输入"
                            @keyup.enter.native="queryCheckDetail()" />
                    </span>
                    <span style="margin-left: 24px;">
                        <span style="margin-right: 12px;">砼强度</span>
                        <el-input v-model="checkDetailParams.productName" style="width: 120px;" placeholder="请输入"
                            @keyup.enter.native="queryCheckDetail()" />
                    </span>
                    <span style="margin-left: 24px;">
                        <span style="margin-right: 12px;">浇筑方式</span>
                        <el-input v-model="checkDetailParams.pourMethod" style="width: 120px;" placeholder="请输入"
                            @keyup.enter.native="queryCheckDetail()" />
                    </span>
                    <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="queryCheckDetail()">查
                        询</el-button>
                    <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                        置</el-button>
                    <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="exportSettle()">导
                        出</el-button>
                    <el-button v-if="!isLook" size="medium" class="bottom_all" style="margin-left: 12px"
                        @click="addItem()">添 加</el-button>
                </div>
                <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe :data="checkDetailTableData"
                    :summary-method="getSummaries" show-summary tooltip-effect="dark" :row-class-name="tableRowClassName">
                    <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
                    <template v-for="(item, index) in checkDetailTable">
                        <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width"
                            :fixed="item.fixed" :show-overflow-tooltip="item.label == '产品名称'" align="center">
                            <template v-if="item.children">
                                <template v-for="(item2, index2) in item.children">
                                    <el-table-column v-if="item2" :key="index2" :prop="item2.prop" :label="item2.label"
                                        :width="item2.width" align="center">
                                        <template slot-scope="scope">
                                            <span v-if="item2.label == '强度等级'">
                                                <el-select v-model="scope.row.strengthGrade" placeholder="请选择"
                                                    @change="$forceUpdate()">
                                                    <el-option v-for="item in strengthGradeArr" :key="item.id"
                                                        :label="item.name" :value="item.name"
                                                        @click.native="changeProductName(scope.$index)"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item2.label == '性能等级'">
                                                <el-select v-model="scope.row.performanceRate" multiple placeholder="请选择"
                                                    @change="$forceUpdate()">
                                                    <el-option v-for="item in performanceRateArr" :key="item.id"
                                                        :label="item.name" :value="item.name"
                                                        @click.native="changeProductName(scope.$index)"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item2.label == '材料要求'">
                                                <el-select v-model="scope.row.materialRequirements" multiple
                                                    placeholder="请选择" @change="$forceUpdate()">
                                                    <el-option v-for="item in materialRequirementsArr" :key="item.id"
                                                        :label="item.name" :value="item.name"
                                                        @click.native="changeProductName(scope.$index)"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item2.label == '特殊要求'">
                                                <el-select v-model="scope.row.specialRequirements" multiple
                                                    placeholder="请选择" @change="$forceUpdate()">
                                                    <el-option v-for="item in specialRequirementsArr" :key="item.id"
                                                        :label="item.name" :value="item.name"
                                                        @click.native="changeProductName(scope.$index)"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item2.label == '其他要求'">
                                                <el-select v-model="scope.row.otherRequirements" multiple placeholder="请选择"
                                                    @change="$forceUpdate()">
                                                    <el-option v-for="item in otherRequirementsArr" :key="item.id"
                                                        :label="item.name" :value="item.name"
                                                        @click.native="changeProductName(scope.$index)"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item2.label == '外加剂要求'">
                                                <el-select v-model="scope.row.admixtureRequirements" multiple
                                                    placeholder="请选择" @change="$forceUpdate()">
                                                    <el-option v-for="item in admixtureRequirementsArr" :key="item.id"
                                                        :label="item.name" :value="item.name"
                                                        @click.native="changeProductName(scope.$index)"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item2.label == '米数'">
                                                <el-input v-model="scope.row.superHighLevel" placeholder="请输入"
                                                    :disabled="isLook"
                                                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                                                    @input="scope.row.superHighLevel = $regExp.checkNum(scope.row.superHighLevel)"
                                                    @blur="scope.row.superHighLevel = $regExp.blurCheckNum(scope.row.superHighLevel, true)"></el-input>
                                            </span>
                                            <span v-else-if="item2.label == '方量(m³)'">
                                                <el-input v-model="scope.row.superHighLevelNum" placeholder="请输入"
                                                    :disabled="isLook"
                                                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                                                    @input="scope.row.superHighLevelNum = $regExp.checkNum(scope.row.superHighLevelNum)"
                                                    @blur="scope.row.superHighLevelNum = $regExp.blurCheckNum(scope.row.superHighLevelNum, true)"></el-input>
                                            </span>
                                            <span v-else>{{ scope.row[item2.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </template>
                            <template slot-scope="scope">
                                <span v-if="item.label == '站点信息'">
                                    <el-select v-model="scope.row.stationId"
                                        :disabled="scope.row.dataSource * 1 == 0 || isLook" style="width: 120px"
                                        placeholder="请选择站点">
                                        <el-option v-for="item in stationIdlist" :key="item.stationId"
                                            :label="item.stationName" :value="item.stationId"
                                            @click.native="scope.row.stationName = item.stationName; scope.row.stationCode = item.code"></el-option>
                                    </el-select> </span>
                                <span v-else-if="item.label == '送货时间'">
                                    <el-date-picker v-model="scope.row.indexTime"
                                        :disabled="scope.row.dataSource * 1 == 0 || isLook"
                                        value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:170px;"
                                        placeholder="选择日期" default-time="08:00:00">
                                    </el-date-picker>

                                </span>
                                <span v-else-if="item.label == '浇筑部位'"> <el-input v-model="scope.row.pourPart"
                                        style="width:180px" :disabled="scope.row.dataSource == 0 || isLook"
                                        placeholder="请输入" />
                                </span>
                                <span v-else-if="item.label == '产品名称'">
                                    <span v-if="dataType !== 4">
                                        <span v-if="scope.row.productName"
                                            :class="['table_link', { 'table_link--disabled': scope.row.dataSource * 1 == 0 }]"
                                            style="cursor: pointer" @click="selectProductName(scope.$index)">{{
                                                scope.row.productName }}</span>
                                        <span v-else class="table_link" style="cursor: pointer"
                                            @click="selectProductName(scope.$index)">选择</span>
                                    </span>
                                    <span v-else>
                                        <el-input v-model="scope.row.productName" style="width:180px"
                                            :disabled="scope.row.dataSource == 0 || isLook" placeholder="请输入" />
                                    </span>
                                </span>
                                <span v-else-if="item.label == '车次'">
                                    <el-input v-model="scope.row.carNumber" placeholder="请输入"
                                        :disabled="scope.row.dataSource == 0 || isLook"
                                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                                        @input="scope.row.carNumber = $regExp.checkNum(scope.row.carNumber)">
                                        </el-input>
                                        <!-- @blur="scope.row.carNumber = $regExp.blurCheckNum(scope.row.carNumber, true);
                                        scope.row.sureNum = $regExp.blurCheckNum(scope.row.carNumber, true); 
                                        scope.row.pumpNum = $regExp.blurCheckNum(scope.row.carNumber, true)" -->
                                </span>
                                <span v-else-if="item.label == '客户签收量(m³)'">
                                    <el-input v-model="scope.row.customerSignNum" placeholder="请输入"
                                        :disabled="scope.row.dataSource == 0 || isLook"
                                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                                        @input="scope.row.customerSignNum = $regExp.checkNum(scope.row.customerSignNum)"
                                        ></el-input>
                                        <!-- @blur="scope.row.customerSignNum = $regExp.blurCheckNum(scope.row.customerSignNum, true); scope.row.sureNum = $regExp.blurCheckNum(scope.row.customerSignNum, true); scope.row.pumpNum = $regExp.blurCheckNum(scope.row.customerSignNum, true)" -->
                                </span>
                                <span v-else-if="item.label == '确认车次'">
                                    <el-input v-model="scope.row.sureCarNumber" placeholder="请输入"
                                        :disabled="isLook"
                                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                                        @input="scope.row.sureCarNumber = $regExp.checkNum(scope.row.sureCarNumber)"
                                       ></el-input>
                                       <!--  @blur="scope.row.sureCarNumber = $regExp.blurCheckNum(scope.row.sureCarNumber, true); scope.row.sureNum = $regExp.blurCheckNum(scope.row.sureCarNumber, true); scope.row.pumpNum = $regExp.blurCheckNum(scope.row.sureCarNumber, true)" -->
                                </span>
                                <span v-else-if="item.label == '双方确认砼量(m³)'">
                                    <el-input v-model="scope.row.sureNum" placeholder="请输入" :disabled="isLook"
                                        onkeypress="return( /\d|\.|-/.test(String.fromCharCode(event.keyCode)))"
                                        @input="scope.row.sureNum = $regExp.checkNum3(scope.row.sureNum)"
                                        ></el-input>
                                        <!-- @blur="scope.row.sureNum = $regExp.blurCheckNum(scope.row.sureNum, true)" -->
                                </span>
                                <span v-else-if="item.label == '泵送结算量(m³)'">
                                    <el-input v-model="scope.row.pumpNum" placeholder="请输入" :disabled="isLook"
                                        onkeypress="return( /\d|\.|-/.test(String.fromCharCode(event.keyCode)))"
                                        @input="scope.row.pumpNum = $regExp.checkNum3(scope.row.pumpNum)"
                                        ></el-input>
                                        <!-- @blur="scope.row.pumpNum = $regExp.blurCheckNum(scope.row.pumpNum, true)" -->
                                </span>
                                <span v-else-if="item.label == '小方量补方(m³)'">
                                    <el-input v-model="scope.row.smallVolume" placeholder="请输入" :disabled="isLook"
                                        onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                                        @input="scope.row.smallVolume = $regExp.checkNum(scope.row.smallVolume)"
                                        ></el-input>
                                        <!-- @blur="scope.row.smallVolume = $regExp.blurCheckNum(scope.row.smallVolume, true)" -->
                                </span>
                                <span v-else-if="item.label == '浇筑方式'"> <el-select v-model="scope.row.pourMethod"
                                        :disabled="isLook" placeholder="请选择">
                                        <el-option v-for="item in pumpTypeList" :key="item.id" :label="item.name"
                                            :value="item.name"></el-option>
                                    </el-select> </span>
                                <span v-else-if="item.label == '修改类型'">
                                    <el-select v-model="scope.row.updateTypeId" placeholder="请选择" :disabled="isLook">
                                        <el-option v-for="item in changeTypeList" :key="item.id" :label="item.itemName"
                                            :value="item.id"
                                            @click.native="scope.row.updateType = item.itemName; scope.row.remark = item.itemName"></el-option>
                                    </el-select> </span>
                                <span v-else-if="item.label == '补结日期'"> <el-date-picker v-model="scope.row.repairDate"
                                        :disabled="isLook" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                                        style="width: 170px;" placeholder="选择日期">
                                    </el-date-picker> </span>
                                <span v-else-if="item.label == '备注'">
                                    <el-popover placement="top-start" width="200" trigger="hover"
                                        :content="scope.row.remark">
                                        <el-input slot="reference" v-model="scope.row.remark"  :disabled="isLook" placeholder="请输入" />
                                    </el-popover>
                                    
                                </span>
                                <span v-else-if="item.label == '操作'">
                                    <el-link v-if="!isLook" type="success" :underline="false"
                                        @click="saveDetail(scope.row)">保存</el-link>
                                    <el-link
                                        v-if="!isLook && (dataType !== 4 || (dataType == 4 && scope.row.dataSource * 1 !== 0))"
                                        type="danger" :underline="false" style="margin-left:12px"
                                        @click="deleteDetail(scope.row, scope.$index)">删除</el-link>
                                </span>
                                <span v-else>{{ scope.row[item.prop] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div class="card_bottom">
                    <div class="card_bottom_left">
                        <div class="top_page_totle">总共{{ total }}条</div>
                        <el-pagination :current-page.sync="checkDetailParams.page" :page-size="checkDetailParams.pageSize"
                            :page-sizes="[10, 20, 30, 40, 50, 100]" layout="prev,pager,sizes,next,jumper" :total="total"
                            @size-change="sizeChange" @current-change="queryCheckDetail()"></el-pagination>
                    </div>
                    <div>
                        <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                            @click="queryCheckDetail">刷新</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button class="bottom_all_two" @click="reset">取 消</el-button> -->
                <el-button class="bottom_all" @click="reset">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 产品选择 -->
        <el-dialog :visible.sync="productDig" top="15vh" width="480px" :close-on-click-modal="false">
            <span slot="title" class="dialog-title">选择产品</span>
            <el-form ref="productForm" :model="productForm" :rules="productForm" label-width="120px">
                <el-form-item label="强度等级" prop="settleMouth">
                    <el-select v-model="productForm.strengthGrade" placeholder="请选择" @change="$forceUpdate()">
                        <el-option v-for="item in strengthGradeArr" :key="item.id" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="性能等级">
                    <el-select v-model="productForm.performanceRate" multiple placeholder="请选择" @change="$forceUpdate()">
                        <el-option v-for="item in performanceRateArr" :key="item.id" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="材料要求">
                    <el-select v-model="productForm.materialRequirements" multiple placeholder="请选择"
                        @change="$forceUpdate()">
                        <el-option v-for="item in materialRequirementsArr" :key="item.id" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="特殊要求">
                    <el-select v-model="productForm.specialRequirements" multiple placeholder="请选择"
                        @change="$forceUpdate()">
                        <el-option v-for="item in specialRequirementsArr" :key="item.id" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="其他要求">
                    <el-select v-model="productForm.otherRequirements" multiple placeholder="请选择" @change="$forceUpdate()">
                        <el-option v-for="item in otherRequirementsArr" :key="item.id" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="外加剂要求">
                    <el-select v-model="productForm.admixtureRequirements" multiple placeholder="请选择"
                        @change="$forceUpdate()">
                        <el-option v-for="item in admixtureRequirementsArr" :key="item.id" :label="item.name"
                            :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button class="bottom_all_two" @click="productDig = false">关 闭</el-button>
                <el-button class="bottom_all_two" style="margin-left: 24px" @click="changeProductName">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 导出 -->
        <settleExport :visible.sync="exportDig" :exportForm="exportForm" />
    </div>
</template>
<script>
import { getDicType } from '@/api/common';
import { queryCheckDetailInternal, saveCheckDetailInternal, deleteDetailInternal, saveCheckDetailConfirm, deleteDetailConfirm, queryCheckDetailProcess, saveCheckDetailProcess, deleteDetailProcess, queryPageTotal } from "@/api/wise/settlementTask.js";
import settleExport from "./settleExport.vue";
export default {
    components: {
        settleExport
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        isLook: {
            type: Boolean,
            default: false,
        },
        checkDetailType: {
            type: Number,
            default: 3,
        },
        cycleId: {
            type: String,
            default: "",
        },//为1则是汇总 其余值为单独的工程
        centerRow: {},
        disClostDetail: {},
        stationIdlist: [],
        bindEngList: [],
    },
    data() {
        return {
            tableParams: {
                page: 1,
                pageSize: 10,
                code: "",
                name: "",
                status: 1,//只查询启用状态
            },
            accessToken: "",
            total: 0,
            checkDetailTableData: [],
            checkDetailTable: [
                { label: "站点信息", width: "120", prop: "", status: true, fixed: "left" },
                { label: "送货时间", width: "200", prop: "", status: true, fixed: "left" },
                { label: "浇筑部位", width: "200", prop: "", status: true, fixed: "left" },
                // {
                //     label: "砼强度", width: "auto", prop: "", status: true, children: [
                //         { label: "强度等级", width: "150", prop: "", status: true },
                //         { label: "性能等级", width: "150", prop: "", status: true },
                //         { label: "材料要求", width: "150", prop: "", status: true },
                //         { label: "特殊要求", width: "150", prop: "", status: true },
                //         { label: "其他要求", width: "150", prop: "", status: true },
                //         { label: "外加剂要求", width: "150", prop: "", status: true },
                //     ]
                // },
                { label: "产品名称", width: "200", prop: "productName", status: true, fixed: "left" },
                { label: "车次", width: "auto", prop: "carNumber", status: true },
                { label: "客户签收量(m³)", width: "auto", prop: "customerSignNum", status: true },
                { label: "确认车次", width: "auto", prop: "sureCarNumber", status: true },
                { label: "双方确认砼量(m³)", width: "100", prop: "sureNum", status: true },
                { label: "泵送结算量(m³)", width: "100", prop: "pumpNum", status: true },
                { label: "小方量补方(m³)", width: "auto", prop: "smallVolume", status: true },
                {
                    label: "超高层", width: "auto", prop: "", status: true, children: [
                        { label: "米数", width: "auto", prop: "superHighLevel", status: true },
                        { label: "方量(m³)", width: "auto", prop: "superHighLevelNum", status: true },
                    ]
                },
                { label: "浇筑方式", width: "150", prop: "", status: true },
                { label: "修改类型", width: "150", prop: "", status: true },
                { label: "补结日期", width: "200", prop: "", status: true },
                { label: "备注", width: "150", prop: "", status: true },
                { label: "操作", width: "120", prop: "orgName", status: true },
            ],
            currentRow: {},
            changeTypeList: [],
            checkDetailParams: {
                page: 1,
                pageSize: 10,
                cycleManageId: "",
                sendTime: "",
                pourPart: "",
                productName: "",
                pourMethod: "",
                cycleProcessManageId: "",
            },
            pumpTypeList: [],
            strengthGradeArr: [], //强度等级
            performanceRateArr: [], //性能等级
            materialRequirementsArr: [], //材料要求
            specialRequirementsArr: [], //特殊要求
            otherRequirementsArr: [], //其他要求
            admixtureRequirementsArr: [], //外加剂要求
            dataType: 3,
            productDig: false,
            productForm: {
                strengthGrade: "",
                performanceRate: "",
                materialRequirements: "",
                specialRequirements: "",
                otherRequirements: "",
                admixtureRequirements: "",
            },
            selectIndex: "",
            exportDig: false,
            exportForm: {},
        }
    },
    watch: {
        disClostDetail: {
            handler() {
                //初始化工程交底信息字典
                console.log(this.disClostDetail)
                this.pumpTypeList = this.disClostDetail.pumpType ? JSON.parse(this.disClostDetail.pumpType) : []
                this.strengthGradeArr = this.disClostDetail.strengthGrade ? JSON.parse(this.disClostDetail.strengthGrade) : []
                this.performanceRateArr = this.disClostDetail.performanceRate ? JSON.parse(this.disClostDetail.performanceRate) : []
                this.materialRequirementsArr = this.disClostDetail.materialRequirements ? JSON.parse(this.disClostDetail.materialRequirements) : []
                this.specialRequirementsArr = this.disClostDetail.specialRequirements ? JSON.parse(this.disClostDetail.specialRequirements) : []
                this.otherRequirementsArr = this.disClostDetail.otherRequirements ? JSON.parse(this.disClostDetail.otherRequirements) : []
                this.admixtureRequirementsArr = this.disClostDetail.admixtureRequirements ? JSON.parse(this.disClostDetail.admixtureRequirements) : []
            },
            deep: true,
            immediate: false,
        },
        checkDetailType: {
            handler(val) {
                this.dataType = val
            },
            deep: true,
            immediate: false,
        }
    },
    methods: {
        tableRowClassName({ row }) {

            if (row.dataSource == 1) {
                console.log("add-row")
                return "add-row";
            }
        },
        exportSettle() {
            this.exportForm = {
                engineeringName: this.centerRow.engineeringName,
                lastDueTime: this.centerRow.lastDueTime,
                currentDueTime: this.centerRow.currentDueTime,
                cycleManageId: this.centerRow.id,
                dataType: 1,
                checkDetailType: this.dataType == 4 ? 2 : 1,//2过程核定量  1//内审量、确认量
            }
            if (this.cycleId == 1) {
                let ids = []
                ids.push(this.centerRow.id)
                let engIds = this.bindEngList.map(item => {
                    return item.childCycleId
                })
                ids = [...ids, ...engIds]
                this.exportForm.cycleManageId = ids.join("','")
            }
            this.exportDig = true
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                console.log(column.property)
                if (!values.every(value => isNaN(value * 1))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return Math.round(parseFloat(Number(prev) + Number(curr)) * 1000) / 1000;
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = '-';
                }
            });

            return sums;
        },
        selectProductName(index) {
            this.selectIndex = index
            this.productForm = this.$options.data().productForm
            this.productDig = true
        },
        deleteDetail(row, index) {
            this.$confirm("此操作将删除该信息?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "bottom_all_two",
                confirmButtonClass: "bottom_all",
                type: "warning",
            })
                .then(() => {
                    if (row.id) {
                        let data = { id: row.id };
                        let queryMethod;
                        switch (this.dataType) {
                            case 2:
                                queryMethod = deleteDetailInternal;
                                break;
                            case 3:
                                queryMethod = deleteDetailConfirm;
                                break;
                            case 4:
                                queryMethod = deleteDetailProcess;
                                break;
                        }
                        queryMethod(data).then(res => {
                            if (res.code == 1001) {
                                this.queryCheckDetail();
                                this.$message({
                                    message: "删除成功",
                                    type: "success",
                                });
                            }
                        });
                    } else {
                        this.checkDetailTableData.splice(index, 1)
                    }

                })
                .catch(() => { });
        },
        saveDetail(row) {
            if (!row.updateTypeId) {
                this.$message.warning('请选择修改类型！')
                return
            }
            if (!row.productName) {
                this.$message.warning('请选择产品名称！')
                return
            }
            if (!row.customerSignNum && row.customerSignNum != 0) {
                this.$message.warning('请输入客户签收量！')
                return
            }
            if (!row.sureNum && row.sureNum != 0) {
                this.$message.warning('请输入双方确认砼量！')
                return
            }
            if (!row.pumpNum && row.pumpNum != 0) {
                this.$message.warning('请输入泵送结算量！')
                return
            }
            if (!row.smallVolume && row.smallVolume != 0) {
                this.$message.warning('请输入小方量补方！')
                return
            }
            if (!row.superHighLevel && row.superHighLevel != 0) {
                this.$message.warning('请输入超高层米数！')
                return
            }
            if (!row.superHighLevelNum && row.superHighLevelNum != 0) {
                this.$message.warning('请输入超高层方量！')
                return
            }
            if (!row.updateType == '下期补结') {
                this.$message.warning('请选择补结日期！')
                return
            }
            if ((row.customerSignNum != row.sureNum || row.customerSignNum != row.pumpNum) && !row.remark) {
                this.$message.warning('客户签收量不等于双方确认砼量、泵送结算量，请填写备注！')
                return
            }
            let queryMethod;
            switch (this.dataType) {
                case 2:
                    queryMethod = saveCheckDetailInternal;
                    break;
                case 3:
                    queryMethod = saveCheckDetailConfirm;
                    break;
                case 4:
                    queryMethod = saveCheckDetailProcess;
                    break;
            }
            row['newCycleManageId'] = this.centerRow.id
            queryMethod(row).then(res => {
                if (res.code == 1001) {
                    this.$message.success('保存成功!')
                    // this.checkDetailParams.page = 1
                    this.queryCheckDetail();
                }
            })
        },
        addItem() {
            let obj = {
                cycleManageId: this.centerRow.id,
                cycleProcessManageId: this.centerRow.id,
                stationId: "",
                stationName: "",
                indexTime: "",
                pourPart: "",
                productName: "",
                productNameSpit: "",
                customerSignNum: "",
                sureNum: "",
                pumpNum: "",
                smallVolume: "",
                superHighLevel: "",
                superHighLevelNum: "",
                pourMethod: "",
                updateTypeId: "",
                updateType: "",
                repairDate: "",
                remark: "",
                dataSource: 1,
            }
            this.checkDetailTableData.push(obj)
        },
        changeProductName() {
            if (!this.productForm.strengthGrade) {
                this.$message.warning('强度等级不能为空！')
                return
            }
            let obj = this.productForm
            console.log(this.productForm)
            let splitName = obj.strengthGrade +
                (obj.performanceRate ? ',' + obj.performanceRate.join(',') : '') +
                (obj.materialRequirements ? ',' + obj.materialRequirements.join(',') : '') +
                (obj.specialRequirements ? ',' + obj.specialRequirements.join(',') : '') +
                (obj.otherRequirements ? ',' + obj.otherRequirements.join(',') : '') +
                (obj.admixtureRequirements ? ',' + obj.admixtureRequirements.join(',') : '')
            console.log(splitName)
            this.$set(this.checkDetailTableData[this.selectIndex], 'productNameSpit', splitName)
            this.$set(this.checkDetailTableData[this.selectIndex], 'productName', splitName.replace(/,/g, ''))
            this.productDig = false
        },
        queryCheckDetail() {
            if (this.cycleId == 1) {
                let ids = []
                ids.push(this.centerRow.id)
                let engIds = this.bindEngList.map(item => {
                    return item.childCycleId
                })
                ids = [...ids, ...engIds]
                this.checkDetailParams.cycleManageId = ids.join(',')
                queryPageTotal(this.checkDetailParams).then(res => {
                    if (res.code == 1001) {
                        this.checkDetailTableData = res.data.data
                        this.total = res.data.totalRows
                    }
                })
            } else {
                let queryMethod
                switch (this.dataType) {
                    case 2:
                        queryMethod = queryCheckDetailInternal;
                        break;
                    case 3:
                        queryMethod = queryCheckDetailInternal;
                        break;
                    case 4:
                        queryMethod = queryCheckDetailProcess;
                        break;
                }
                queryMethod(this.checkDetailParams).then(res => {
                    if (res.code == 1001) {
                        this.checkDetailTableData = res.data.data
                        this.total = res.data.totalRows
                    }
                })
            }

        },
        open() {
            this.dataType = this.checkDetailType
            this.init()
            getDicType({ code: 'settleTaskUpdateType' }).then(res => {
                this.changeTypeList = res.data.items;
            });
        },
        submitDept() {
            if (this.currentRow.length == 0) {
                this.$message.warning("请选中一条数据");
                return;
            }
            this.$emit("setDept", this.currentRow)
            this.reset()
        },
        reset() {
            this.$emit("resetCheckDetail");
        },
        sizeChange(value) {
            this.checkDetailParams.pageSize = value;
            this.queryCheckDetail();
        },
        init() {
            this.checkDetailParams = this.$options.data().checkDetailParams
            this.checkDetailParams.cycleManageId = this.centerRow.id
            this.checkDetailParams.cycleProcessManageId = this.centerRow.id
            this.queryCheckDetail();
        },
    }
}
</script>
<style lang="scss" scoped>
.addClass {
    display: flex;
    justify-content: end;
    margin-bottom: 15px;
}

.mr15 {
    margin-right: 15px;
}

.table_link {
    margin-left: 10px;
    color: $bg_color;
}

.table_link:hover {
    opacity: 0.8;
}

.table_link--disabled {
    color: #00b85c;
    /* 灰色表示禁用 */
    cursor: not-allowed;
    /* 禁用光标 */
    pointer-events: none;
    /* 禁用点击事件 */
    text-decoration: none;
    /* 去掉下划线 */
}

::v-deep .el-table__body tr.current-row>td {
    color: #fff;
    background: #00b85c !important;
}

::v-deep .el-table__fixed {
    pointer-events: none;
}

::v-deep .el-table__fixed .el-table__fixed-body-wrapper {
    pointer-events: auto;
}

::v-deep .add-row {
    background: #FFB9B9 !important;
}
</style>